import { TextCombinedProps } from './types';

const usePresenter = (props: TextCombinedProps): TextCombinedProps => {
  return props;
};

export default usePresenter;
